import { render, staticRenderFns } from "./NoPhonePay.vue?vue&type=template&id=7796d77c&"
import script from "./NoPhonePay.vue?vue&type=script&lang=js&"
export * from "./NoPhonePay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports